import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import Icon from '@mdi/react';
import { Collapse, IconButton } from '@mui/material';
import React, { useCallback, useState } from 'react';

interface SimpleAccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

export const SimpleAccordion = ({ title, children }: SimpleAccordionProps) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = useCallback(() => setOpen(!open), [open]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleOpen();
      }
    },
    [toggleOpen]
  );

  return (
    <div className='simple-box'>
      <div className='simple-accordion' onClick={toggleOpen} onKeyDown={handleKeyDown} tabIndex={0} style={{ cursor: 'pointer' }}>
        <div style={{ flexGrow: 1 }}>{title}</div>
        <IconButton aria-label='expand row' size='small'>
          <Icon size={1.5} path={open ? mdiChevronUp : mdiChevronDown} color={'#2E6CD1'} />
        </IconButton>
      </div>
      <div className={open ? 'is-expansion-visible' : ''}>
        <Collapse in={open} timeout='auto' unmountOnExit className='simple-accordion-box'>
          <div style={{ padding: '16px' }}>{children}</div>
        </Collapse>
      </div>
    </div>
  );
};
